/**
 * Manages Mixpanel super properties - global context attached to all events
 */

import mixpanelService from '../mixpanel-service'
import { PROPS, SCHEMA_VERSION } from './analytics-spec'
import packageJson from '../../../package.json'

class SuperPropertiesManager {
    constructor() {
        if (SuperPropertiesManager.instance) {
            return SuperPropertiesManager.instance
        }
        SuperPropertiesManager.instance = this
        this._initialized = false
    }

    /**
     * Get static properties that never change during session
     */
    getStaticProps() {
        return {
            [PROPS.PLATFORM]: 'web',
            [PROPS.SCHEMA_VERSION]: SCHEMA_VERSION,
            [PROPS.ENVIRONMENT]: import.meta.env.VITE_ENV || 'dev',
            [PROPS.APP_VERSION]: packageJson.version
        }
    }

    /**
     * Initialize super properties - call after mixpanel init, before any tracking
     */
    initialize() {
        if (this._initialized) return

        mixpanelService.registerSuperProps({
            ...this.getStaticProps(),
            [PROPS.IS_LOGGED_IN]: false
        })
        this._initialized = true
    }

    /**
     * Update user status on login/logout
     */
    updateUserStatus(isLoggedIn, memberId) {
        if (isLoggedIn && memberId) {
            mixpanelService.registerSuperProps({
                [PROPS.IS_LOGGED_IN]: true,
                [PROPS.MEMBER_ID]: memberId
            })
        } else {
            mixpanelService.registerSuperProps({
                [PROPS.IS_LOGGED_IN]: false
            })
            mixpanelService.unregisterSuperProp(PROPS.MEMBER_ID)
        }
    }
}

export default new SuperPropertiesManager()
